import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useSetDefaultVendor, useTelephonyMe } from '@/models/telephony'

export function DefaultVendorToggle() {
  const { data } = useTelephonyMe()
  const setDefault = useSetDefaultVendor()

  if (!data) return null

  const { defaultVendor, vendors } = data

  if (vendors.length < 2) {
    return (
      <p className="text-sm">
        Telephony vendor: <span className="font-medium capitalize">{defaultVendor ?? 'none linked'}</span>
      </p>
    )
  }

  return (
    <div className="flex items-center gap-3">
      <label className="text-sm font-medium">Default telephony vendor</label>
      <Select
        value={defaultVendor ?? ''}
        onValueChange={(v) => setDefault.mutate(v as 'aircall' | 'dialpad')}
        disabled={setDefault.isPending}
      >
        <SelectTrigger className="w-36">
          <SelectValue placeholder="Select vendor" />
        </SelectTrigger>
        <SelectContent>
          {vendors.map((v) => (
            <SelectItem key={v.vendor} value={v.vendor}>
              <span className="capitalize">{v.vendor}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
